export default __webpack_public_path__ + "static/media/azure.d99459ce.png";